<template>
  <div class="w-full bg-gray-500 bg-opacity-50 fixed h-full z-[190] grid top-0">
    <slot></slot>
  </div>
</template>
